import axios from 'axios';
import {
	getChooseSimulation,
	getStorageReportSim,
	getLocalStorageData,
	setLocalStorageData
} from './storageFunctions';
import { COOKIE_HEADER, COOKIE_STORAGE_KEY } from '@/helpers/constants';

export default function setup(router) {
	function handleError(error) {
		if (
			error.config.hasOwnProperty('errorHandle') &&
			error.config.errorHandle === false
		) {
			return Promise.reject(error);
		}

		if (error.response.status === 401) {
			router.push('/login');
		} else if (error.response.status === 500) {
			router.push('/internalerror');
		} else if (error.response.status === 404) {
			router.push('/notfound');
		}

		return Promise.reject(error.response);
	}

	axios.defaults.baseURL = process.env.VUE_APP_API_URL;

	axios.interceptors.response.use(response => {
		// Get already stored data
		const ceDate = getLocalStorageData(COOKIE_STORAGE_KEY);
		const cookieHeader = response.headers[COOKIE_HEADER];
		// store new value only if the two are different
		// this is needed because this op will be triggered
		// on every axios request.
		if (ceDate && cookieHeader && ceDate !== cookieHeader) {
			// set expiration date for later usage
			setLocalStorageData(COOKIE_STORAGE_KEY, response.headers[COOKIE_HEADER]);
		}

		return Promise.resolve(response);
	}, handleError);

	axios.interceptors.request.use(
		config => {
			config.headers.srid = sessionStorage.getItem('srid');
			config.headers.studentFacilityId = sessionStorage.getItem(
				'studentFacilityId'
			);

			config.headers.cookieExpiresUtc = getLocalStorageData('ceUTC');

			if (sessionStorage.getItem('viewAsStudent')) {
				const viewAsStudent = JSON.parse(
					sessionStorage.getItem('viewAsStudent'),
					true
				);

				Object.keys(viewAsStudent).forEach(key => {
					config.headers[key] = viewAsStudent[key];
				});
			}
			const simObject = getChooseSimulation();
			if (simObject.id) {
				config.headers.simulationId = simObject.id;
				config.headers.studentId = simObject.sid;
			}

			const simForReport = getStorageReportSim();

			if (simForReport) {
				config.headers.studentId = simForReport.sid;
				config.headers.simulationId = simForReport.id;
			}

			return config;
		},
		error => Promise.reject(error)
	);
}
